import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FastTrackExaminationPage from './Main';
import { drivingTest } from 'Store/Selectors/DrivingTestSelector';
import { getDrivingTest, getDrivingTestAnswer, finishDrivingTest } from 'Store/Actions/DrivingTest';
import { saveTask } from 'Store/Actions/Lesson';
import { authorizedUser } from 'Store/Selectors/AuthSelector';
import { getAuthorizedUser } from 'Store/Actions/Auth';
import { User } from 'Shared/models/UserModel';

type ConnectedP = {
  drivingTest: any;
  authorizedUser: User | 'init';
};

type DispatchedP = {
  actions: {
    getDrivingTest: () => any;
    getDrivingTestAnswer: (params) => any;
    finishDrivingTest: (uuid, options?: { fastTrack?: boolean }) => any;
    getAuthorizedUser: () => (dispatch: any) => Promise<any>;
    saveTask: (data) => (dispatch: any) => Promise<any>;
  };
};

const mapStateToProps = (state) => ({
  drivingTest: drivingTest(state),
  authorizedUser: authorizedUser(state),
});

const mapDispatchToProps = (dispatch): DispatchedP => ({
  actions: bindActionCreators(
    {
      getAuthorizedUser,
      getDrivingTest,
      getDrivingTestAnswer,
      finishDrivingTest,
      saveTask,
    },
    dispatch,
  ),
});

export type MainType = ConnectedP & DispatchedP;

export default connect(mapStateToProps, mapDispatchToProps)(FastTrackExaminationPage);
